import { render, staticRenderFns } from "./TranProgramModuleUpdate.vue?vue&type=template&id=790d0e3d&scoped=true"
import script from "./TranProgramModuleUpdate.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranProgramModuleUpdate.vue?vue&type=style&index=0&id=790d0e3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d0e3d",
  null
  
)

export default component.exports